"use client";

import React, { useState } from "react";
import FAQSection from "@/components/Pages/Help/FAQSection";
import ContactForm from "@/components/Pages/Help/ContactForm";
import HeroSection from "@/components/Pages/Help/HeroSection";
import ReachOutSection from "@/components/Pages/Help/ReachOutSection";

const faqSections = [
  {
    title: "Getting Started",
    items: [
      {
        id: "1",
        question: "Create an account",
        answer:
          "To create an account, click on 'Sign Up' and fill out the required fields.",
      },
      {
        id: "4",
        question: "How do I update my profile information?",
        answer:
          "Go to 'Settings' in your dashboard and update your profile information.",
      },
    ],
  },
  {
    title: "Account and Login",
    items: [
      {
        id: "5",
        question: "How do I delete my account?",
        answer:
          "To delete your account, contact our support team at support@rawiah.com.",
      },
      {
        id: "6",
        question: "I forgot my password",
        answer:
          "Click on 'Forgot Password' at the login page to reset your password.",
      },
      {
        id: "7",
        question: "How do I change my email or password?",
        answer:
          "Go to 'Settings' in your dashboard and navigate to the 'Account' section to update your email or password.",
      },
      {
        id: "8",
        question: "Why can’t I log into my account?",
        answer:
          "Ensure your login credentials are correct or reset your password if necessary.",
      },
    ],
  },
  {
    title: "Payments and Billing",
    items: [
      {
        id: "9",
        question: "What payment methods do you accept?",
        answer:
          "We accept major credit cards, PayPal, and other payment methods depending on your location.",
      },
      {
        id: "10",
        question: "How can I view my purchase history?",
        answer:
          "Go to the 'Billing' section in your dashboard to view your purchase history.",
      },
      {
        id: "11",
        question: "How do I update payment information?",
        answer:
          "In the 'Billing' section, click on 'Update Payment Info' to modify your payment details.",
      },
      {
        id: "12",
        question: "Can I cancel or get a refund?",
        answer:
          "Refer to our refund policy or contact support for assistance with cancellations or refunds.",
      },
    ],
  },
  {
    title: "Policies and Privacy",
    items: [
      {
        id: "13",
        question: "What is your refund policy?",
        answer:
          "Our refund policy is available on the 'Terms and Policies' page of our website.",
      },
      {
        id: "14",
        question: "How do you handle my personal data?",
        answer:
          "We prioritize your privacy. Read our 'Privacy Policy' for detailed information.",
      },
      {
        id: "15",
        question: "Where can I read your terms?",
        answer:
          "Visit our 'Terms and Conditions' page for detailed terms of service.",
      },
      {
        id: "16",
        question: "How do I provide feedback or suggestions?",
        answer:
          "You can send your feedback or suggestions to feedback@example.com.",
      },
    ],
  },
];


function Page() {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeQuery, setActiveQuery] = useState("");
  const [filteredQuestions, setFilteredQuestions] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = () => {
    const results: any[] = [];

    faqSections.forEach((section) => {
      const matchingItems = section.items.filter((item) =>
        item.question.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      if (matchingItems.length > 0) {
        results.push(...matchingItems);
      }
    });

    setFilteredQuestions(results);
    setActiveQuery(searchQuery);
    setIsSearching(true);
  };

  const handleBack = () => {
    setActiveQuery("");
    setSearchQuery("");
    setFilteredQuestions([]);
    setIsSearching(false);
  };

  const highlightQuery = (text: string) => {
    if (!activeQuery) return text;

    const regex = new RegExp(`(${activeQuery})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="font-bold text-[#4887F5]">
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  return (
    <div className="overflow-hidden">
      <div>
        <div className="bg-white">
          {/* First Section - Hero + Search */}
          <HeroSection
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            handleSearch={handleSearch}
          />

          {/* Second Section - Questions */}
          <FAQSection
            isSearching={isSearching}
            handleBack={handleBack}
            filteredQuestions={filteredQuestions}
            faqSections={faqSections}
            highlightQuery={highlightQuery}
          />

          {/* Third Section - Contact Form */}
          <ContactForm />

          {/* Fourth Section - Reach Out */}
          <ReachOutSection />
        </div>
      </div>
    </div>
  );
}

export default Page;
